module.exports = __webpack_public_path__ + "img/shorting.13f8909d.svg";